import { Navigate, Route, Routes } from 'react-router-dom'

import { Root } from './Root'
import { PersonalData } from '../../../pages/expert/PersonalData'
import { BankData } from '../../../pages/expert/BankData'
import { CompleteRegistration } from '../../../pages/expert/CompleteRegistration'
import { Skills } from '../../../pages/expert/Skills'
import { ChangeExpertPassword } from '../../../pages/expert/ChangeExpertPassword'
import { TermOfParticipation } from '../../../pages/expert/TermOfParticipation'
import { PersonTypesStepper } from '../../../pages/expert/PersonalData/pages/PersonTypesStepper'
import { Meetings } from '../../../pages/expert/Meetings'

export const PrivateRoutes = () => {
  return (
    <Routes>
      <Route element={<Root />}>
        <Route path="meetings" element={<Meetings />} />
        <Route path="personal-data">
          <Route path="stepper" element={<PersonTypesStepper />} />
          <Route index element={<PersonalData />} />
        </Route>
        <Route path="bank-data" element={<BankData />} />
        <Route path="skills" element={<Skills />} />
        <Route path="change-password" element={<ChangeExpertPassword />} />
        <Route
          path="complete-registration"
          element={<CompleteRegistration />}
        />
        <Route path="term-of-participation" element={<TermOfParticipation />} />
        <Route path="*" element={<Navigate to="/expert/complete-registration" />} />
        <Route index element={<Meetings />} />
      </Route>
    </Routes>
  )
}
